import React from "react";

const ArrowIcon = () => (
  <svg
    className="ml-1 h-5 w-5"
    fill="currentColor"
    viewBox="0 0 20 20"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

const LinkIcon = () => (
  <svg
    className="mb-3 h-10 w-10 text-purple-600 md:h-12 md:w-12 dark:text-purple-500"
    fill="currentColor"
    viewBox="0 0 20 20"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm14 1a1 1 0 11-2 0 1 1 0 012 0zM2 13a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm14 1a1 1 0 11-2 0 1 1 0 012 0z"
      clipRule="evenodd"
    />
  </svg>
);

const UsersIcon = () => (
  <svg
    className="mb-3 h-10 w-10 text-purple-600 md:h-12 md:w-12 dark:text-purple-500"
    fill="currentColor"
    viewBox="0 0 20 20"
    aria-hidden="true"
  >
    <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
  </svg>
);

const GlobeIcon = () => (
  <svg
    className="mb-3 h-10 w-10 text-purple-600 md:h-12 md:w-12 dark:text-purple-500"
    fill="currentColor"
    viewBox="0 0 20 20"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z"
      clipRule="evenodd"
    />
  </svg>
);

const ManageIcon = () => (
  <svg
    className="mb-3 h-10 w-10 text-purple-600 md:h-12 md:w-12 dark:text-purple-500"
    fill="currentColor"
    viewBox="0 0 20 20"
    aria-hidden="true"
  >
    <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
  </svg>
);

const DigitalIdentity = () => {
  const features = [
    {
      title: "One Bio Link",
      description:
        "Bring all your important links, social profiles and websites together in one place.",
      icon: <LinkIcon />,
    },
    {
      title: "For Everyone",
      description:
        "Perfect for creators, businesses, influencers, artists and professionals building their online presence.",
      icon: <UsersIcon />,
    },
    {
      title: "Share Anywhere",
      description:
        "Add your ZeedBio link to Instagram, TikTok, Facebook, YouTube, WhatsApp and anywhere your audience can find you.",
      icon: <GlobeIcon />,
    },
    {
      title: "Easy to Manage",
      description:
        "Add, edit, organize and update your links anytime from one simple ZeedBio dashboard.",
      icon: <ManageIcon />,
    },
  ];

  return (
    <section className="bg-white dark:bg-gray-900" id="features">
      <div className="mx-auto max-w-screen-xl items-center px-4 py-12 lg:grid lg:grid-cols-4 lg:gap-16 lg:px-6 lg:py-24 xl:gap-24">

        {/* Left Content */}
        <div className="col-span-2 mb-12 lg:mb-0">
          <p className="text-sm font-bold tracking-wider text-purple-600 dark:text-purple-500">
            BUILT FOR YOUR DIGITAL IDENTITY
          </p>

          <h2 className="mt-3 mb-5 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 md:text-4xl lg:text-5xl dark:text-white">
            One link to connect your audience with{" "}
            <span className="text-purple-600">
              everything you do.
            </span>
          </h2>

          <p className="font-light leading-relaxed text-gray-500 sm:text-xl dark:text-gray-400">
            ZeedBio helps creators, businesses, brands and professionals bring
            their most important links together in one simple and beautiful
            page. Share one link everywhere and make it easy for people to find
            you.
          </p>

          {/* Links */}
          <div className="mt-8 space-y-4 border-t border-gray-200 pt-6 dark:border-gray-700">
            <a
              href="/register"
              className="flex w-fit items-center text-base font-semibold text-purple-600 transition hover:translate-x-1 hover:text-purple-800 dark:text-purple-500 dark:hover:text-purple-400"
            >
              Create your ZeedBio
              <ArrowIcon />
            </a>

            <a
              href="#features"
              className="flex w-fit items-center text-base font-semibold text-purple-600 transition hover:translate-x-1 hover:text-purple-800 dark:text-purple-500 dark:hover:text-purple-400"
            >
              Explore ZeedBio features
              <ArrowIcon />
            </a>
          </div>
        </div>

        {/* Right Features */}
        <div className="col-span-2 grid gap-8 sm:grid-cols-2 md:gap-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="rounded-2xl border border-gray-100 bg-gray-50 p-6 transition duration-300 hover:-translate-y-1 hover:shadow-lg dark:border-gray-800 dark:bg-gray-800/50"
            >
              {feature.icon}

              <h3 className="mb-3 text-xl font-bold text-gray-900 md:text-2xl dark:text-white">
                {feature.title}
              </h3>

              <p className="font-light leading-relaxed text-gray-500 dark:text-gray-400">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DigitalIdentity;